import React, { Component } from "react";
import $ from "jquery";
import PdfViewer from "./PdfViewer";
import StandardSelectModal from "./StandardSelectModal";
import SuggestionsList from "./SuggestionsList";

class ReportAccountStatusModal extends Component {
    //#region Component Actions
    constructor(props) {
        super(props);
        this.state = {
            filters:{
                cardCode: "---",
            },

            showBPSuggestion: false,
            businessParterSuggestions: [],

            showSelectBPModal: false,
        };
        this.businessParterInput = React.createRef();
    }

    componentDidMount() {
        const { branchOffices = [] } = this.props;
        if (branchOffices.length > 0) {
            this.setState({ branchOffices: branchOffices.sort((a, b) => a.project.toLowerCase().localeCompare(b.project.toLowerCase())) });
        }
    }

    close() {
        $("#ReportAccountStatus").modal("hide");
    }
    //#endregion

    //#region Open Selection Modals
    openBusinessPartnerModal = async () => {
        await this.setState({ showSelectBPModal: true });
        $("#selectBPModal").modal("show");
        $("#selectBPModal").on("hidden.bs.modal", async () => {
            await this.setState({ showSelectBPModal: false });
        });
    }
    //#endregion

    //#region Update Filters
    updateBP = (value = "") => {
        const { suggestionCatalogs: { businessPartnerCCatalog } } = this.props;
        let { filters } = this.state;
        filters.businessPartner = value;
        filters.cardCode = "---";

        let businessParterSuggestions = [];
        
        if (value.trim() !== "") {
            const searchTokens = value.toLowerCase().split(" ");
            businessParterSuggestions = businessPartnerCCatalog.filter(record => {
                const tokens = (record?.CardCode + " " + record?.CardName + " " + record?.LicTradNum).toLowerCase().split(" ");
                return searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token))
            )}).slice(0, 15);
        }

        const showBPSuggestion = businessParterSuggestions.length > 0;
        this.setState({ filters, businessParterSuggestions, showBPSuggestion });
    }

    selectBP = (businessParter) => {
        let { filters } = this.state;
        filters.businessPartner = businessParter.CardName;
        filters.cardCode = businessParter.CardCode;
        this.setState({ filters, businessParterSuggestions: [], showBPSuggestion: false });
        $("#selectBPModal").modal("hide");
    }
    //#endregion

    render() {
        const {
            suggestionCatalogs: {
                businessPartnerCCatalog = [],
            },
            
            // Standard Props
            GenerateReport,
            ListReports,
            ShowPDFViewerModal,
            ShowPDFViewer,
            ReportsModel,
            MailTools,
            printhide,
            ShowFormatToPrint,
        } = this.props;
        const {
            filters:{
                businessPartner,
            },
            showBPSuggestion,
            businessParterSuggestions,
            showSelectBPModal,
        } = this.state;

        let inputBPRect = { width: 0 , height: 0, top: 0, left: 0, bottom: 0, right: 0 };
        if (this.businessParterInput.current) inputBPRect = this.businessParterInput.current.getBoundingClientRect();

        return (
            <div className="no-select">
                <div id="ReportAccountStatus" className="modal fade bd-example-modal-lg">
                    <div className="modal-dialog modal-dialog-centered modal-md" role="document" >
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{backgroundColor:"#343a40",borderRadius:"0"}}>
                                <h4 className="modal-title" id="modal-basic-title"> Reporte de Cartera de Crédito</h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtBusinessPartner"> Cliente </label>
                                        </div>
                                        <input
                                            ref={this.businessParterInput}
                                            id="txtBusinessPartner"
                                            className="form-control"
                                            type="text"
                                            autoComplete="off"
                                            value={businessPartner}
                                            onChange={({target: { value }}) => this.updateBP(value)}
                                            onBlur={() => this.setState({ businessParterSuggestions: [], showBPSuggestion: false })} />
                                        <div className="input-group-prepend">
                                            <button className="btn btn-outline-warning rounded-right" onClick={this.openBusinessPartnerModal}> <i className="fa fa-list"/> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.close}>Cerrar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReport(this.state.filters)}>Generar</button>
                            </div>
                        </div>
                    </div>

                    {showBPSuggestion &&
                        <SuggestionsList
                            suggestions={businessParterSuggestions}
                            keys={[
                                { field: "CardCode", classes: "key", styles: { minWidth: 75, maxWidth: 75} },
                                { field: "CardName", classes: "", styles: { minWidth: inputBPRect.width - 100, maxWidth: inputBPRect.width - 100 } },
                            ]}
                            action={this.selectBP}
                            styles={{ maxHeight: 200 }}
                            rect={inputBPRect} />
                    }
                </div>

                {showSelectBPModal &&
                    <StandardSelectModal
                        id="selectBPModal"
                        title="Clientes"
                        data={businessPartnerCCatalog}
                        selectAction={this.selectBP}
                        searchBar={businessPartner}

                        headers={[
                            { title: "Código", value: true, filter: true, field: "CardCode", format: null, classes: "text-left" },
                            { title: "Cliente", value: true, filter: true, field: "CardName", format: null, classes: "text-left" },
                            { title: "RUT", value: false, filter: true, field: "LicTradNum", format: null, classes: "text-left" },
                        ]}

                        actPos="start" />
                }

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={"ReportAccountStatus"}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={"SalesTools.EditableDocModel"}
                        RefreshDocModel={"SalesTools.RefreshDocModel"}
                        SaveChanges={"SalesTools.SaveChangesOrderInvoice"}
                        UploadDoc={"SalesTools.UploadInvoice"}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={"user"}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false} 
                        downloadCSV= {true}
                        />
                }
            </div>
        );
    }
}

export default ReportAccountStatusModal;